export default __webpack_public_path__ + "static/media/connective.0957a335.jpg";